// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../assets/fonts/Nunito/Nunito.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.casehistory {
  font-family: montserrat !important;
}
.casehistorybutton {
  font-family: montserrat !important;
}

.labcasehistoryfont {
  font-family: Nunito, sans-serif !important;
}
.labcasehistoryfontbutton {
  font-family: Nunito, sans-serif !important;
}

.case_info_container {
  border: 1.5px solid #17a0b4;
  padding: 5px;
  position: relative;
  margin-block: 16px;
  width: 22vw;
}

.card_label_title {
  background-color: #fbfbfb;
  position: absolute;
  padding-inline: 5px;
  top: -11px;
  font-weight: 600;
  font-size: 12px;
  color: #001C3B !important;
}

.overxflow_caseinfo {
  overflow-x: hidden !important;
}

.padding_leftinpx {
  padding-left: 5px;
}

.lables_style {
  font-size: 10px;
  color: #001C3B;
  font-weight: 600;
}

.value_style {
  font-weight: 600;
  font-size: 10px;
  color: #5682A6 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.view_case {
  width: 100%;
  background: #376B96;
  color: white;
  line-height: 11px;
  font-size: 12px;
  cursor: pointer;
  font-family: montserrat !important;
}

.labview_case {
  width: 100%;
  background: #376B96;
  color: white;
  line-height: 11px;
  font-size: 12px;
  cursor: pointer;
  font-family: Nunito, sans-serif !important;
}

.timezone-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 8px 80px;
  height: 40px;
  z-index: 1000;
}
.timezone-notice .timezone-notice-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
  height: 100%;
  padding-left: 15px;
}
.timezone-notice .timezone-notice-content i {
  margin-right: 8px;
  color: #17a2b8;
  font-size: 14px;
}
.timezone-notice .timezone-notice-content span {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/casehistory/casehistory.component.scss"],"names":[],"mappings":"AAEA;EACE,kCAAA;AAAF;AACE;EACE,kCAAA;AACJ;;AAGA;EACE,0CAAA;AAAF;AACE;EACE,0CAAA;AACJ;;AAGA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAAF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kCAAA;AAEF;;AAAA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,0CAAA;AAGF;;AACA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AAAI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAEN;AACI;EACE,gBAAA;AACN","sourcesContent":["@import 'src/assets/fonts/Nunito/Nunito.css';\r\n\r\n.casehistory{\r\n  font-family: montserrat !important;\r\n  &button{\r\n    font-family: montserrat !important;\r\n\r\n  }\r\n}\r\n.labcasehistoryfont{\r\n  font-family: Nunito, sans-serif !important;\r\n  &button{\r\n    font-family: Nunito, sans-serif !important;\r\n\r\n  }\r\n}\r\n.case_info_container{\r\n  border: 1.5px solid #17a0b4;\r\n  padding: 5px;\r\n  position: relative;\r\n  margin-block: 16px;\r\n  width: 22vw;\r\n}\r\n.card_label_title{\r\n  background-color: #fbfbfb;\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  top: -11px;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  color: #001C3B !important;\r\n}\r\n\r\n.overxflow_caseinfo{\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.padding_leftinpx{\r\n  padding-left: 5px;\r\n}\r\n\r\n.lables_style{\r\n  font-size: 10px;\r\n  color: #001C3B;\r\n  font-weight: 600;\r\n}\r\n.value_style{\r\n  font-weight: 600;\r\n  font-size: 10px;\r\n  color:#5682A6 !important;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.view_case{\r\n  width: 100%;\r\n  background: #376B96;\r\n  color: white;\r\n  line-height: 11px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  font-family: montserrat !important;\r\n}\r\n.labview_case{\r\n  width: 100%;\r\n  background: #376B96;\r\n  color: white;\r\n  line-height: 11px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  font-family: Nunito, sans-serif !important;\r\n}\r\n\r\n// Timezone Notice Styles - Fixed at bottom of screen\r\n.timezone-notice {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #dee2e6;\r\n  padding: 8px 80px;\r\n  height: 40px;\r\n  z-index: 1000;\r\n  \r\n  .timezone-notice-content {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    font-size: 12px;\r\n    color: #6c757d;\r\n    font-style: italic;\r\n    height: 100%;\r\n    padding-left: 15px;\r\n    \r\n    i {\r\n      margin-right: 8px;\r\n      color: #17a2b8;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    span {\r\n      font-weight: 500;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
